import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimedArticleComponent } from './article/article.component';
import { SimedReceptionEchantillionComponent } from './simed-reception-echantillion/simed-reception-echantillion.component';
import { SimedAnalyseComponent } from './simed-analyse/simed-analyse.component';
import { SharedModule } from '../shared/shared.module';
import { UnigesLayoutModule } from '@unilog/template';
import { environment } from 'src/environments/environment';
import { UnigesInputModule } from '@unilog/input';
import { DiversysModule } from '@unilog/diversys';

@NgModule({
  declarations: [
    SimedArticleComponent,
    SimedReceptionEchantillionComponent,
    SimedAnalyseComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DiversysModule.forRoot({ api: environment.apiEndPoint, tableDiverSys: 'DiverSys' }),
    UnigesInputModule,
    UnigesLayoutModule.forRoot(environment.apiEndPoint),
  ]
})
export class SimedModule { }
